import { FlowDurationUnits, FlowFormCompletionWorkflowSignals } from 'flow-schema';

import { BlockDurationField } from '../../ConfigFields/Duration.tsx';
import { BlockSelectField } from '../../ConfigFields/SelectField.tsx';

export function WaitForFormCompletionFormFields() {
  return (
    <>
      <BlockSelectField
        fieldName="config.signalName"
        label="Form Completion Event"
        clearable={false}
        required
        options={[
          {
            value: FlowFormCompletionWorkflowSignals.FormSetCompleted,
            label: 'Completed',
            subHeader: 'The form has been completed and submitted',
          },
          {
            value: FlowFormCompletionWorkflowSignals.FormSetExpired,
            label: 'Expired',
            subHeader: 'The form expired before being completed',
          },
          {
            value: FlowFormCompletionWorkflowSignals.FormSetTerminal,
            label: 'Terminal',
            subHeader: 'Either the form was Completed or it has Expired',
          },
        ]}
      />
      <BlockDurationField
        fieldName="config.timeout"
        valueLabel="Time to Wait Before Failing Flow"
        unitFieldNameSuffix="units"
        allowedUnits={Object.values(FlowDurationUnits)}
        required
      />
    </>
  );
}
